/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Events_TitleInputs */

const en_features_events_title = /** @type {(inputs: Features_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const pl_features_events_title = /** @type {(inputs: Features_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenia`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Features_Events_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_events_title = /** @type {((inputs?: Features_Events_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Events_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_events_title(inputs)
	return en_features_events_title(inputs)
});